<template>
  <div class="text-center">
    <v-dialog v-model="shower" width="900" persistent>
      <v-card class="rounded-lg">
        <v-card-title v-if="DataConsent.Type === 'Group'">
          {{ $t("dashboard.groupconsentdetail") }} <v-spacer></v-spacer>
        </v-card-title>
        <v-card-title v-else-if="DataConsent.Type === 'General'">
          {{ $t("dashboard.gconsentdetail") }} <v-spacer></v-spacer>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-6">
          <v-layout row wrap ml-3 pa-1>
            <v-flex v-if="$t('default') === 'th'" xs11 lg11
              ><b class="mr-2">{{ $t("dashboard.policy") }} :</b>
              <a v-on:click="Fn_DetailPolicy">{{ PolicyHeader }} </a>
              <br />
              <b>{{ $t("dashboard.org") }} :</b> {{ BusinessNameTh }}
            </v-flex>
            <v-flex v-else xs11 lg11
              ><b class="mr-2">{{ $t("dashboard.policy") }} :</b>
              <a v-on:click="Fn_DetailPolicy">{{ PolicyHeader }} </a>
              <br />
              <b>{{ $t("dashboard.org") }} :</b> {{ BusinessNameEng }}
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-divider></v-divider>
        <v-card height="500" class="overflow-auto elevation-0">
          <v-card-text>
            <div
              v-for="(item, index) in Consent"
              :key="index"
              class="overflow-auto"
            >
              <v-card-title primary-title>
                {{ index + 1 }}. {{ $t("consentform.head") }}
                <b class="ml-2">{{ item.ConsentHeader }}</b>
              </v-card-title>
              <v-card-text>
                <v-layout row wrap ml-3 pa-1>
                  <v-flex xs11 lg11>
                    <div class="pb-2">
                      <b> {{ $t("dashboard.status") }} </b>
                      <b v-if="item.Status === 'approve'" class="green--text">
                        {{ $t("dashboard.statusapp") }}</b
                      >
                      <b
                        v-else-if="item.Status === 'unapprove'"
                        class="red--text"
                      >
                        {{ $t("dashboard.statusreject") }}</b
                      >
                      <b
                        v-else-if="item.Status === 'wait'"
                        class="orange--text"
                      >
                        {{ $t("dashboard.statuspen") }}</b
                      >
                    </div>
                    <div class="pb-1">
                      <b>{{ $t("dashboard.detail") }}</b>
                    </div>
                    <div v-html="item.ConsentDetail"></div>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </div>
          </v-card-text>
        </v-card>
        <v-card-actions class="pb-5 pa-3">
          <v-spacer></v-spacer>
          <v-btn color="error" outlined @click="Fn_Close()" dark>
            {{ $t("consentform.close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div v-if="loadingDownloadData">
      <OverlaySearch />
    </div>
    <DialogGeneralConsent
      :show="DialogGeneral"
      :_header="PolicyHeader"
      :_detail="PolicyDetail"
      @closeDialogDelete="DialogGeneral = false"
    />
  </div>
</template>
<script>
import OverlaySearch from "@/components/layouts/LoadingPage.vue";
import DialogGeneralConsent from "@/components/dialog/DialogGeneralConsentDetail.vue";
import authorization from "@/functions/authorization.js";
import Swal2 from "sweetalert2/dist/sweetalert2.js";
import { mapGetters } from "vuex";
// import { mapGetters } from 'vuex'
const Toast = Swal2.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});

export default {
  components: { DialogGeneralConsent, OverlaySearch },
  props: ["show"],
  data: function () {
    return {
      Consent: [],
      DataConsent: [],
      PolicyHeader: "",
      PolicyName: "",
      PolicyDetail: "",
      BusinessNameTh: "",
      BusinessNameEng: "",
      Status: "",
      loadingDownloadData: false,
      DialogGeneral: false,
      heading: "Sample PDF Generator",
      moreText: [
        "This is another few sentences of text to look at it.",
        "Just testing the paragraphs to see how they format.",
        "jsPDF likes arrays for sentences.",
        "Do paragraphs wrap properly?",
        "Yes, they do!",
        "What does it look like?",
        "Not bad at all.",
      ],
      items: [
        { title: "Item 1", body: "I am item 1 body text" },
        { title: "Item 2", body: "I am item 2 body text" },
        { title: "Item 3", body: "I am item 3 body text" },
        { title: "Item 4", body: "I am item 4 body text" },
      ],
    };
  },
  computed: {
    shower: {
      ...mapGetters(["DataGeneralConsent"]),
      ...mapGetters(["DataGroupConsent"]),
      ...mapGetters(["Business"]),
      _SendId: {
        get() {
          return this.DataGroupConsent.SendId || "-";
        },
      },
      _SendId: {
        get() {
          return this.DataGeneralConsent.SendId || "-";
        },
      },
      get() {
        return this.show;
      },
      set(value) {
        if (!value) {
          this.$emit("closeDialog");
        }
      },
    },
  },
  mounted() {
    // this.Fn_GetDataPolicy();
  },
  methods: {
    Fn_Close() {
      this.$emit("closeDialog");
    },
    async Fn_GetDataPolicy() {
      this.loadingDownloadData = true;
      var payload = {
        Email: this.$cookies.get('EmailCMP'),
        AccessToken: this.$cookies.get('EmailAccessToken'),
        SendId: this.$cookies.get("SendId"),
      };
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE + "email/GetConsentId",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          this.loadingDownloadData = false;
          this.show = true;

          if (response.data.Status === "OK") {
            this.DataConsent = response.data.Message;
            this.Consent = response.data.Message.Consent;
            this.PolicyName = response.data.Message.Name;
            this.PolicyHeader = response.data.Message.PolicyHeader;
            this.PolicyDetail = response.data.Message.PolicyDetail;
            this.BusinessNameTh = response.data.Message.BusinessNameTh;
            this.BusinessNameEng = response.data.Message.BusinessNameEng;
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          this.loadingDownloadData = false;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title:
                this.$i18n.t("alert.contactserve") +
                error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: this.$i18n.t("alert.contactserve") + error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title:
                this.$i18n.t("alert.contactserve") + error.message || error,
            });
          }
        });
    },
    Fn_DetailPolicy() {
      this.DialogGeneral = true;
    },
    async Fn_DownloadPdf() {
      this.loadingDownloadData = true;
      var payload = {
        UserName: this.$cookies.get("OneUsername"),
        AccountId: this.$cookies.get("OneAccountId"),
        BusinessNameEng: this.DataConsent.BusinessNameEng,
        BusinessNameTh: this.DataConsent.BusinessNameTh,
        Consent: this.DataConsent.Consent,
        ConsentId: this.DataConsent.ConsentId,
        Email: this.DataConsent.Email,
        GroupId: this.DataConsent.GroupId,
        GroupName: this.DataConsent.GroupName,
        Name: this.DataConsent.Name,
        PolicyDetail: this.DataConsent.PolicyDetail,
        PolicyHeader: this.DataConsent.PolicyHeader,
        PolicyId: this.DataConsent.PolicyId,
        SendId: this.DataConsent.SendId,
        SourceSystem: this.DataConsent.SourceSystem,
        Tel: this.DataConsent.Tel,
        Type: this.DataConsent.Type,
      };
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE + "report/gennerate/pdf",
          { Data: dataEncode },
          { headers },
          { responseType: "arraybuffer" }
        )
        .then((response) => {
          const blob = new Blob([response.data], {
            type: "application/pdf",
          });
          var DateTime = new Date().toISOString().slice(0, 10);
          var link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = "GeneralConsent" + DateTime + ".pdf";
          link.click();
          this.loadingDownloadData = false;
        });
    },
  },
  watch: {
    show(val) {
      if (val) {
        this.Fn_GetDataPolicy();
      }
    },
  },
};
</script>
